import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

// Import persist
import { QueryParamStore } from './QueryParamStore';

// Import helpers
import { CONFIGURATOR_MODE, CONFIGURATOR_RESTORE } from '../helpers/variables';
import { obfuscate } from 'helpers/localstorage';
import { merge } from 'lodash';

const { CREATE } = CONFIGURATOR_MODE;
const { NONE } = CONFIGURATOR_RESTORE;

const initialState = {
	mode: CREATE,
	restore: NONE,
	main: null,
	premium: [],
	current: null
};

const storage = QueryParamStore(false);
const name = 'pakiety';

const partialize = (state) => ({
	restore: state.restore,
	main: state.main,
	premium: state.premium
});

export const useOfferStore = create(
	immer(
		persist(
			(set, get) => ({
				...initialState,
				hasAnySelected: () => {
					const { main, premium } = get();
					return [main, ...premium].filter(Boolean).some(({ uuid }) => uuid);
				},
				isSelected: (packet) => {
					const { main, premium } = get();
					if (main && main.uuid === packet.uuid) return true;
					if (premium && premium.some((p) => p.uuid === packet.uuid))
						return true;
					return false;
				},
				/* -------------------- Main --------------------------- */
				toggleMainPacket: (packet) =>
					set((state) => {
						state.main = state.main?.uuid === packet.uuid ? null : packet;
					}),

				/* -------------------- Premium --------------------------- */
				togglePremiumPacket: (packet) =>
					set((state) => {
						if (state.isSelected(packet)) {
							state.premium = state.premium.filter(
								(p) => p.uuid !== packet.uuid
							);
						} else {
							state.premium.push(packet);
						}
					}),

				unselectPremiumPackets: (packets) => {
					set((state) => {
						state.premium = state.premium.filter(
							({ uuid }) => !packets.includes(uuid)
						);
					});
				},

				/* -------------------- Current --------------------------- */

				setCurrent: ({ main, premium, status, paymentStatus }) =>
					set((state) => {
						state.current = { main, premium, status, paymentStatus };
					}),

				/* -------------------- Utils --------------------------- */
				setMode: (mode) =>
					set((state) => {
						state.mode = mode;
					}),
				setRestore: (restore) =>
					set((state) => {
						state.restore = restore;
					}),
				reset: () => {
					set((state) => {
						state.main = null;
						state.premium = [];
						state.current = null;
						state.restore = NONE;
					});
				}
			}),
			{
				name,
				storage,
				partialize,
				merge: (persisted, current) => {
					if (persisted.restore !== NONE) {
						return merge(current, persisted);
					}
					return merge(current, initialState);
				}
			}
		)
	)
);

export const getPersistedData = () => {
	const state = partialize(useOfferStore.getState());
	const version = useOfferStore.persist.getOptions().version;
	return obfuscate({ state, version });
};
